import { createSlice } from "@reduxjs/toolkit";
import { deleteGroceryAPI } from "../../api/dishes";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const deleteGrocerySlice = createSlice({
  name: "deleteGrocery",
  initialState: data,
  reducers: {
   deleteGrocerySlice(state) {
      state.isLoading = true;
    },
   deleteGrocerySliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteGrocerySliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteGrocerySliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const deleteGroceryHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(deleteGroceryAction.deleteGrocerySlice());
    const response: any = await deleteGroceryAPI(id);
    
    dispatch(deleteGroceryAction.deleteGrocerySliceSuccess(response));
  } catch (e: any) {
    dispatch(deleteGroceryAction.deleteGrocerySliceFailure(e?.response?.data));
  }
};
export default deleteGrocerySlice.reducer;
export const deleteGroceryAction = deleteGrocerySlice.actions;
